module.exports = __webpack_public_path__ + "static/media/more-menu-hover.27e54a22.svg";